export type AnchorType = 'right' | 'left' | 'top' | 'bottom' | 'rightOverlay' | 'rightPersistent' | 'rightChatUserList'

export type ToggleDrawer = (
  event: React.KeyboardEvent | React.MouseEvent | null,
  anchor: AnchorType,
  open: boolean,
  location?: string
) => void

export enum Routes {
  welcome = 'event',
  stream = 'stream',
  sessions = 'public-sector-use-cases',
  demos = 'other-use-cases',
  contact = 'contact',
  about = 'about',
  support = 'support',
  replay = 'event-replay'
}
